<template>
  <ul
    slot="content"
    class="list"
  >
    <li
      v-for="(item, i) in list"
      :key="i"
      class="list__element list__element--dashed"
      v-html="renderItem(item)"
    />
  </ul>
</template>

<script>
import highlightRenderer from '@/lib/highlight-renderer';

export default {
  name: 'BulletPointList',
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    renderItem(text) {
      return highlightRenderer(text);
    },
  },
};
</script>
